import PanelBlockAlignment from "../../lib/panel/panel-block-alignment";
import PanelContainer from "../../lib/panel/panel-container";
import type { RateOrderBlockProps } from "./types";

export function RateOrderEmailPanelRenderer(blockProps: RateOrderBlockProps) {
  return (
    <PanelContainer blockProps={blockProps}>
      <PanelBlockAlignment />
    </PanelContainer>
  );
}
